<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Form :model="ReportAndDisposeForm">
        <FormItem label="时间">
          <DatePicker type="daterange" v-model="ReportAndDisposeForm.signTime" placeholder="选择日期"
                      @on-change="getReportAndDisposeData" clearable @on-clear="clearData"></DatePicker>
        </FormItem>
      </Form>
      <Table ref="ReportAndDisposeRefs" :data="ReportAndDisposeData" :columns="ReportAndDisposeColumns"
             :loading="ReportAndDisposeLoading"></Table>
      <Button type="primary" style="float: left;margin-top: 10px" @click="exportReportAndDispose">导出附件
      </Button>
    </Card>
  </div>
</template>
<script>
export default {
  name: 'ReportAndDispose',
  data() {
    return {
      ReportAndDisposeData: [],
      ReportAndDisposeColumns: [
        {title: '单位', key: 'dept', align: 'center'},
        {title: '事件上报数', key: 'eventEscalationNumber', align: 'center'},
        {title: '事件处置完成数', key: 'eventHandleFinishNumber', align: 'center'},
        {title: '处置完成率', key: 'handleFinishRate', align: 'center'},
        {title: '未办结数', key: 'notFinishNumber', align: 'center'},
      ],
      ReportAndDisposeLoading: false,
      ReportAndDisposeForm: {
        signTime: ['', '']
      }
    }
  },
  mounted() {
    this.ReportAndDisposeForm.signTime = [this.$moment().subtract(1, 'weeks').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
    this.getReportAndDisposeData()
  },
  methods: {
    exportReportAndDispose() {
      this.$refs.ReportAndDisposeRefs.exportCsv({
        filename: this.$moment(new Date()).format('yyyy-MM-DD') + '应急事件上报及处置情况',
      })
    },
    clearData() {
      this.ReportAndDisposeForm.signTime = [this.$moment().subtract(1, 'weeks').format('YYYY-MM-DD'), this.$moment().format('YYYY-MM-DD')]
      this.getUsageSituationData()
    },
    getReportAndDisposeData() {
      this.ReportAndDisposeLoading = true
      let request = {
        beginDate: new Date(this.ReportAndDisposeForm.signTime[0]),
        endDate: new Date(this.ReportAndDisposeForm.signTime[1])
      }
      this.$http.post(`/api/getEmergencyEventEscalationAndHandleSituation`, request).then(res => {
        if (res.status === 200) {
          this.ReportAndDisposeData = res.data
          this.ReportAndDisposeLoading = false
        }
      })
    },
  }
}
</script>

<style scoped lang="less">

</style>
